/* global debounce, KROWN */

if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {

    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    async deleteLine(lineNumber) {
      await fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript'
        },
        body: JSON.stringify({ line: lineNumber, quantity: 0 })
      });
    }

    ajaxifyCartItems() {

      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {

        const remove = item.querySelector('.remove');
        if (remove) {

          // Keep Shopify’s link in data‑href, but neuter the href attr
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');

          /* ───────────── CLICK HANDLER WITH CASCADE DELETE ───────────── */
          remove.addEventListener('click', async e => {
            e.preventDefault();

            const prodHandle   = remove.dataset.producthandle;        // frame handle or undefined
            const clickedLine  = parseInt(item.dataset.line, 10);
            const linesToKill  = [clickedLine];                        // always nuke the clicked row

            if (prodHandle) {                                          // clicked row is a frame
              this.querySelectorAll('.remove').forEach(lnk => {
                if (lnk.dataset.lensproduct === prodHandle) {         // companion lens row
                  const lensItem = lnk.closest('[data-js-cart-item]');
                  if (lensItem) {
                    linesToKill.push(parseInt(lensItem.dataset.line, 10));
                  }
                }
              });
            }

            // ★ NEW: Remove duplicates and sort in descending order
            const uniqueSorted = [...new Set(linesToKill)].sort((a, b) => b - a);

            for (const ln of uniqueSorted) {
              await this.deleteLine(ln);                              // safe even with multiple companions
            }

            window.refreshCart();                                     // refresh UI and totals
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          qty.addEventListener('input', debounce(e => {
            e.preventDefault();
            e.target.blur();
            this.updateCartQty(item, parseInt(qty.value, 10));
          }, 500));
          qty.addEventListener('click', e => e.target.select());
        }

      });

    }

    updateCartQty(item, newQty) {

      let alert = null;

      this.form.classList.add('processing');
      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line, 10),
        quantity: newQty
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body
      })
        .then(r => r.json())
        .then(r => {
          if (r.status === 422) {
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            alert.innerHTML = typeof r.description === 'string' ? r.description : r.message;
          }
          return fetch('?section_id=helper-cart');
        })
        .then(r => r.text())
        .then(text => {
          const html    = new DOMParser().parseFromString(text, 'text/html');
          const cartDOM = html.getElementById('AjaxCartForm');
          const subDOM  = html.getElementById('AjaxCartSubtotal');

          const cartForm = document.getElementById('AjaxCartForm');
          cartForm.innerHTML = cartDOM.innerHTML;
          cartForm.ajaxifyCartItems();

          document.querySelectorAll('[data-header-cart-count]')
            .forEach(el => el.textContent = cartForm.querySelector('[data-cart-count]').textContent);
          document.querySelectorAll('[data-header-cart-total]')
            .forEach(el => el.textContent = cartForm.querySelector('[data-cart-total]').textContent);

          if (alert) this.form.prepend(alert);

          document.getElementById('AjaxCartSubtotal').innerHTML = subDOM.innerHTML;

          this.dispatchEvent(new Event('cart-updated'));
        })
        .catch(err => {
          console.error(err);
          const alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => this.form.classList.remove('processing'));
    }

  }

  if (!customElements.get('cart-form')) {
    customElements.define('cart-form', CartForm);
  }
}

if (typeof CartProductQuantity !== 'function') {

  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();
      this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
      this.querySelector('.qty-plus' ).addEventListener('click', this.changeCartInput.bind(this));
    }
    changeCartInput() {
      setTimeout(() => {
        document.getElementById('AjaxCartForm')
          .updateCartQty(this.closest('[data-js-cart-item]'),
                         parseInt(this.querySelector('.qty').value, 10));
      }, 50);
    }
  }

  if (!customElements.get('cart-product-quantity')) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}

if (!window.refreshCart) {
  window.refreshCart = () => {
    fetch('?section_id=helper-cart')
      .then(r => r.text())
      .then(text => {

        const html   = new DOMParser().parseFromString(text, 'text/html');
        const cartEl = html.getElementById('AjaxCartForm');
        const subEl  = html.getElementById('AjaxCartSubtotal');

        const cartDOM = document.getElementById('AjaxCartForm');
        cartDOM.innerHTML = cartEl.innerHTML;
        cartDOM.ajaxifyCartItems();

        document.querySelectorAll('[data-header-cart-count]')
          .forEach(el => el.textContent = cartDOM.querySelector('[data-cart-count]').textContent);
        document.querySelectorAll('[data-header-cart-total]')
          .forEach(el => el.textContent = cartDOM.querySelector('[data-cart-total]').textContent);

        document.getElementById('AjaxCartSubtotal').innerHTML = subEl.innerHTML;

        if (document.querySelector('[data-js-site-cart-sidebar]')) {
          document.querySelector('[data-js-site-cart-sidebar]').show();
        }

        if (document.querySelector('cart-recommendations')) {
          const rec = document.querySelector('cart-recommendations');
          rec.innerHTML = '';
          rec.generateRecommendations();
        }
      });
  };
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(evt => {
            fetch(KROWN.settings.routes.cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
              body: JSON.stringify({ note: evt.target.value })
            });
          }, 150)
        );
      }
    }
  );
}
